import { CALENDAR_PAST_EVENT_STYLE } from './calendarOverlayStyles';
import { sharedCalendarStyles } from './sharedCalendarStyles';

/** Tutor lesson calendar — amber studio palette layered on shared FullCalendar styles. */
export const tutorCalendarStyles = {
  ...sharedCalendarStyles,
  '& .fc': {
    '--fc-border-color': 'rgba(0, 0, 0, 0.14)',
  },
  '& .fc-col-header-cell-cushion': {
    fontSize: '14px !important',
    fontWeight: '600 !important',
    padding: '10px 8px !important',
    textAlign: 'center !important',
    textTransform: 'none',
    whiteSpace: 'pre-line !important',
    lineHeight: '1.3 !important',
    backgroundColor: 'rgba(201, 162, 39, 0.14) !important',
    color: '#8B6914 !important',
    borderBottom: '2px solid rgba(201, 162, 39, 0.55) !important',
  },
  '& .fc-col-header-cell': {
    borderRight: '1px solid rgba(0, 0, 0, 0.14) !important',
  },
  '& .fc-timegrid-col, & .fc-timegrid-col-frame': {
    borderRight: '1px solid rgba(0, 0, 0, 0.14) !important',
  },
  '& .fc-timegrid-axis': {
    width: '50px !important',
    minWidth: '50px !important',
    maxWidth: '50px !important',
    backgroundColor: 'rgba(201, 162, 39, 0.1) !important',
    borderRight: '2px solid rgba(201, 162, 39, 0.45) !important',
  },
  '& .fc-timegrid-slot-label-cushion': {
    fontSize: '0.8rem',
    padding: '0 4px !important',
    fontWeight: '500 !important',
    color: '#8B6914 !important',
  },
  '& .fc-monthYearTitle-button': {
    color: '#8B6914 !important',
    fontSize: '1.05rem !important',
    fontWeight: '600 !important',
    textTransform: 'none !important',
    background: 'transparent !important',
    border: 'none !important',
    boxShadow: 'none !important',
  },
  '& .fc-button:hover': {
    backgroundColor: 'rgba(201, 162, 39, 0.12) !important',
    borderColor: '#C9A227 !important',
    color: '#8B6914 !important',
  },
  '& .fc-button.fc-button-active': {
    backgroundColor: '#C9A227 !important',
    borderColor: '#C9A227 !important',
    color: '#ffffff !important',
  },
  '& .fc-event.tutor-lesson-pending': {
    borderStyle: 'dashed !important',
    borderWidth: '2px !important',
    opacity: '0.92 !important',
  },
  '& .fc-event.tutor-lesson-external': {
    borderStyle: 'dotted !important',
    opacity: '0.85 !important',
  },
  // Manual blocks: keep FC event color, overlay diagonal stripes (legend used to
  // claim stripes for working hours but the grid never painted them).
  '& .fc-event.tutor-lesson-manual:not(.past-event), & .fc-event.manual-block:not(.past-event)': {
    borderStyle: 'solid !important',
    borderWidth: '1px !important',
    opacity: '1 !important',
    backgroundImage:
      'repeating-linear-gradient(-45deg, rgba(255,255,255,0.38) 0 4px, rgba(0,0,0,0.14) 4px 9px) !important',
    backgroundBlendMode: 'normal',
  },
  '& .fc-event.past-event:not(.fc-bg-event)': {
    opacity: `${CALENDAR_PAST_EVENT_STYLE.opacity} !important`,
    filter: `saturate(${CALENDAR_PAST_EVENT_STYLE.saturate}) !important`,
  },
  '& .fc-event.tutor-lesson-manual .fc-event-main, & .fc-event.manual-block .fc-event-main': {
    background: 'transparent !important',
  },
};

export const tutorCalendarCompactStyles = `
  .fc-event.tutor-lesson-confirmed {
    box-shadow: inset 3px 0 0 rgba(255, 255, 255, 0.55) !important;
  }
  .fc-event.tutor-lesson-pending {
    box-shadow: inset 3px 0 0 rgba(255, 255, 255, 0.35) !important;
  }
  .fc-event.tutor-lesson-manual:not(.past-event),
  .fc-event.manual-block:not(.past-event) {
    box-shadow: inset 3px 0 0 rgba(255, 255, 255, 0.45) !important;
    background-image: repeating-linear-gradient(
      -45deg,
      rgba(255, 255, 255, 0.38) 0 4px,
      rgba(0, 0, 0, 0.14) 4px 9px
    ) !important;
  }
  .fc-event.past-event:not(.fc-bg-event) {
    opacity: ${CALENDAR_PAST_EVENT_STYLE.opacity} !important;
    filter: saturate(${CALENDAR_PAST_EVENT_STYLE.saturate}) !important;
  }
  .fc-event.tutor-lesson-manual .fc-event-main,
  .fc-event.manual-block .fc-event-main {
    background: transparent !important;
  }

  /* Day separators: FC week slots are a single full-width table, so column
     borders alone often don't show. Paint lines on top of each day column. */
  .fc .fc-timegrid-cols {
    z-index: 3 !important;
  }
  .fc .fc-timegrid-col {
    position: relative !important;
  }
  .fc .fc-timegrid-col:not(:last-child)::after {
    content: '' !important;
    position: absolute !important;
    top: 0 !important;
    right: 0 !important;
    bottom: 0 !important;
    width: 1px !important;
    background: rgba(0, 0, 0, 0.1) !important;
    pointer-events: none !important;
    z-index: 6 !important;
  }
  .fc .fc-col-header-cell {
    position: relative !important;
  }
  .fc .fc-col-header-cell:not(:last-child)::after {
    content: '' !important;
    position: absolute !important;
    top: 0 !important;
    right: 0 !important;
    bottom: 0 !important;
    width: 1px !important;
    background: rgba(0, 0, 0, 0.1) !important;
    pointer-events: none !important;
    z-index: 6 !important;
  }
`;
